export enum TrainingSelfAttendanceRoutesConfig {
	BASE_URL = 'training-self-attendance',
	QRCODE = `${TrainingSelfAttendanceRoutesConfig.BASE_URL}/:qrcode`
}
